import { ExtractParamsInPath } from 'core/services/navigation/utils/extractParamsInPath';

export const replaceParamsInPath = <T extends string>(
  path: T,
  params: ExtractParamsInPath<T>
): string => {
  // NOTE: We need to ignore the searchParams parameter because it is not used in the path replacement
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { searchParams, ...pathParams } = params as Record<string, unknown> & {
    searchParams?: Record<string, string | undefined | null>;
  };

  return Object.entries(pathParams).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, String(value)),
    path as string
  );
};
